import React, { useState } from "react";
import { Box, TextField, Button, Menu, MenuItem, IconButton } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const TemplateSearch = ({ searchText, handleSearch, selectedType, handleMenuClick, handleMenuClose, anchorEl, availableStates }) => {
    return (
        <Box
            className="search-bar-template2 tw-w-full sm:tw-w-auto"
            sx={{
                alignItems: "center",
                justifyContent: { xs: "stretch", sm: "center" },
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 1, sm: 2 },
                height: { xs: "auto", sm: "45px" },
                ml: { xs: 0, lg: 2 },
                width: { xs: "100%", sm: "auto" },
            }}
        >
            <Box sx={{ position: "relative", height: "45px", width: { xs: "100%", sm: "auto" } }}>
                <TextField
                    sx={{
                        fontWeight: "400",
                        fontSize: "11px",
                        position: "relative",
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        height: "41px",
                        width: { xs: "100%", sm: "200px", md: "250px" },
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "6px",
                            height: "41px",
                        },
                    }}
                    variant="outlined"
                    size="medium"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => handleSearch(e.target.value)}
                    InputProps={{
                        endAdornment: (
                            <IconButton>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16.5 16.5L12.875 12.875M14.8333 8.16667C14.8333 11.8486 11.8486 14.8333 8.16667 14.8333C4.48477 14.8333 1.5 11.8486 1.5 8.16667C1.5 4.48477 4.48477 1.5 8.16667 1.5C11.8486 1.5 14.8333 4.48477 14.8333 8.16667Z"
                                        stroke="#667085"
                                        strokeWidth="1.66667"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </IconButton>
                        ),
                    }}
                />
            </Box>
            <Box sx={{ position: "relative", width: { xs: "100%", sm: "auto" } }}>
                <Button
                    onClick={handleMenuClick}
                    sx={{
                        textTransform: "none",
                        fontSize: { xs: "11px", sm: "12px" },
                        fontWeight: "400",
                        fontFamily: "Roboto",
                        border: "0.99px solid #D0D5DD",
                        cursor: "pointer",
                        color: "black",
                        gap: "2px",
                        backgroundColor: "white",
                        alignItems: "center",
                        height: "41px",
                        borderRadius: "5px",
                        width: { xs: "100%", sm: "auto" },
                        minWidth: { xs: "auto", sm: "120px" },
                    }}
                >
                    <FilterListIcon className="tw-text-[14px]" />
                    {selectedType}
                    <KeyboardArrowDownIcon className="tw-text-[14px]" />
                </Button>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleMenuClose(null)}>
                    {availableStates.map((state) => (
                        <MenuItem key={state.value} onClick={() => handleMenuClose(state)}>
                            {state.label}
                        </MenuItem>
                    ))}
                </Menu>
            </Box>
            {/* <Box sx={{ position: "relative" }}>
                <Button
                    onClick={handleRecentlyUsedClickInternal}
                    className={`${recentlyUsed ? "tw-bg-primary hover:tw-bg-primary_hover" : "#FFFFFF"}`}
                    sx={{
                        textTransform: "none",
                        fontSize: "13px",
                        fontWeight: "400",
                        fontFamily: "Roboto",
                        height: "41px",
                        minHeight: "41px",
                        maxHeight: "41px",
                        cursor: "pointer",
                        color: recentlyUsed ? "#FFFFFF" : "#344054",
                        p: "15px",
                        border: !recentlyUsed ? "0.99px solid #D0D5DD" : null,
                        borderRadius: "5px",
                        boxShadow: recentlyUsed ? "0px 1.65px 22.06px rgba(14, 8, 84, 0.05)" : null,
                        lineHeight: "16px",
                        "&:hover": {
                            backgroundColor: recentlyUsed ? "#00153299" : "#FFFFFF",
                            color: recentlyUsed ? "#FFFFFF" : "#344054",
                            border: !recentlyUsed ? "0.99px solid #D0D5DD" : null,
                        },
                    }}
                >
                    Recently Used
                </Button>
            </Box> */}
        </Box>
    );
};

export default TemplateSearch;
